import { useEffect, useState } from 'react';
import { Outlet, ScrollRestoration, useLocation } from 'react-router';
import { useLiveSync } from '@/api/useLiveSync';
import { useChain } from '@/chain/ChainProvider';
import { openPalette } from '@/store/ui';
import { SearchPalette } from './SearchPalette';
import { BrandHeader } from './BrandHeader';
import { SettingsDialog } from './SettingsDialog';
import { SetupBanner } from './SetupBanner';
import { SlidersHorizontal } from 'lucide-react';
import '@/pages/raydius-pages.css';

const CLUSTER_LABEL = { mainnet: 'SOLANA MAINNET', devnet: 'SOLANA DEVNET', local: 'LOCAL CLONE' } as const;

export function AppShell() {
  const isHome = useLocation().pathname === '/';
  const [settings, setSettings] = useState(false);
  const { config, setupMode } = useChain();
  useLiveSync();
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        openPalette();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);
  return (
    <div className="raydius-app flex h-dvh overflow-hidden bg-bg">
      <div className="flex min-w-0 flex-1 flex-col">
        {!isHome && <BrandHeader />}
        {!isHome && <SetupBanner />}
        <main id="main" className={isHome ? 'min-h-0 flex-1 overflow-y-auto' : 'raydius-pages min-h-0 flex-1 overflow-y-auto'}>
          <Outlet />
        </main>
        {!isHome && <footer className="app-foot"><span><i className={setupMode ? '' : 'is-live'} /> {setupMode ? 'LAUNCHING SOON' : CLUSTER_LABEL[config.cluster]}</span><span>0% PLATFORM FEE</span><button onClick={() => setSettings(true)} aria-label="Trade settings"><SlidersHorizontal size={12} /> Settings</button></footer>}
      </div>
      <SearchPalette />
      <SettingsDialog open={settings} onOpenChange={setSettings} />
      <ScrollRestoration />
    </div>
  );
}
